import { useState } from "react";
import { Plus, Trophy } from "lucide-react";
import ScorecardBoard from "../components/scorecard/ScorecardBoard";
import ScorecardHistory from "../components/scorecard/ScorecardHistory";
import ScorecardReport from "../components/scorecard/ScorecardReport";
import { AddProjectModal } from "../components/scorecard/ScorecardModals";
import { useScorecard } from "../components/scorecard/useScorecard";

const VIEWS = [["board", "Leaderboard"], ["closed", "Closed projects"], ["history", "History"]];

export default function TeamScorecard() {
  const [view, setView] = useState("board");
  const [adding, setAdding] = useState(false);
  const live = useScorecard();
  const all = useScorecard({ includeClosed: true, poll: false });
  const closed = (all.projects || []).filter((p) => p.status !== "active");
  return (
    <div className="space-y-4" data-testid="team-scorecard-page">
      <div className="flex items-center gap-3 flex-wrap">
        <Trophy className="w-5 h-5 text-amber-300" />
        <h1 className="text-xl font-semibold text-white">Scorecard</h1>
        <span className="text-xs text-white/50">Budget − penalties + rewards = balance. Everyone can see the live board.</span>
        {live.can_edit && (
          <button className="ml-auto hv-btn-primary text-xs px-3 py-1.5 inline-flex items-center gap-1" onClick={() => setAdding(true)} data-testid="scorecard-add-project">
            <Plus className="w-3.5 h-3.5" /> Add project
          </button>
        )}
      </div>
      <div className="flex gap-1 border-b border-white/10">
        {VIEWS.concat(live.can_edit ? [["report", "Report & statements"]] : []).map(([k, l]) => (
          <button key={k} onClick={() => setView(k)} data-testid={`scorecard-view-${k}`}
            className={`px-3 py-1.5 text-xs ${view === k ? "text-white border-b-2 border-cyan-400" : "text-white/50"}`}>{l}</button>
        ))}
      </div>
      {view === "board" && <ScorecardBoard projects={live.projects} canEdit={live.can_edit} onChanged={() => { live.reload(); all.reload(); }} />}
      {view === "closed" && <ScorecardBoard projects={closed} canEdit={live.can_edit} onChanged={all.reload} emptyText="No closed scorecard projects." />}
      {view === "history" && <ScorecardHistory />}
      {view === "report" && live.can_edit && <ScorecardReport />}
      {adding && <AddProjectModal onClose={() => setAdding(false)} onDone={() => { live.reload(); all.reload(); }} />}
    </div>
  );
}
